import { RequestService } from '@/services/request.service'
import ServerDirections from '@/config/server-directions'
import { ExtendedTransaction } from '@/entities/Transaction'
const requestService = new RequestService()

export class TransactionRequests {
  list (filters) {
    const { limit, offset, order, accountIds, guestId, stationId, stationIds, currencyIds, currencyType, reference, createdSince, createdUntil, type } = filters
    const route = ServerDirections.TRANSACTIONS
    const method = 'get'
    function map (data) {
      return {
        list: data.data.map(item => new ExtendedTransaction(item)),
        hasNext: data.meta.has_next,
      }
    }
    var params = {
      limit, offset,
    }
    if (accountIds) {
      params.account_ids = accountIds.toString() || []
    }
    if (order) {
      params.order = order
    }
    if (guestId) {
      params.guest_id = guestId
    }
    if (stationId) {
      params.station_id = stationId
    }
    if (stationIds) {
      params.station_ids = stationIds
    }
    if (currencyIds) {
      params.currency_ids = currencyIds.toString() || []
    }
    if (currencyType) {
      params.currency_type = currencyType
    }
    if (reference) {
      params.reference = reference
    }
    if (createdSince) {
      params.created_since = createdSince
    }
    if (createdUntil) {
      params.created_until = createdUntil
    }
    if (type) {
      params.type = type
    }
    return requestService.makePromise(route, method, { params }, map)
  }
}
